import { getCspNonce } from './utils/cspNonce';

/**
 * Dynamically loads the secured configuration after authentication.
 * The securedConfig.js script uses Object.assign to merge values into window.ENV.
 * This must only be called after the user has been authenticated.
 *
 * The server requires a valid Authorization header to serve this file,
 * preventing direct browser access via URL.
 */
export const loadSecuredConfig = async(accessToken: string): Promise<void> => {
  return await fetch('/config/securedConfig.js', {
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load secured config: ${response.status}`);
      }
      return response.text();
    })
    .then((scriptContent) => {
      // Execute the script in the global scope so it can assign to window.ENV.
      // The nonce must match the server-injected CSP nonce so script-src allows it.
      const script = document.createElement('script');
      script.nonce = getCspNonce();
      script.textContent = scriptContent;
      document.body.appendChild(script);
      document.body.removeChild(script);
      console.log('Secured config loaded successfully');
    })
    .catch((error) => {
      console.error('Failed to load secured config', error);
      throw error;
    });
};
